import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import {
  InputKeys,
} from 'constants/constants';

const enhanceWithNavigation = (Component) => {
  const StyledComponent = styled(Component)`
    &:hover {
      cursor: pointer;
    }
  `;

  class ComponentWithNavigation extends React.Component {
    onNavigationClick = async () => {
      const { history, path, onClick, disable } = this.props;
      // Call Wrapped Component's onClick
      if (onClick) { onClick(); }
      // Navigate to location { path }
      if (!disable) {
        history.push(await path);
      }
    };

    handleKeyDown = async (event) => {
      const { history, path, handleKeyDownEvent } = this.props;
      const { key } = event;
      
      if (handleKeyDownEvent && (key === InputKeys.ENTER_KEY)) {
        history.push(await path);
      }
    };

    render() {
      return (
        <StyledComponent {...this.props} onKeyDown={this.handleKeyDown} onClick={this.onNavigationClick} />
      );
    }
  }

  ComponentWithNavigation.propTypes = {
    history: PropTypes.object.isRequired,
    path: PropTypes.any.isRequired,
    onClick: PropTypes.func,
    disable: PropTypes.bool,
  };

  return withRouter(ComponentWithNavigation);
};

export default enhanceWithNavigation;
